// extracted by mini-css-extract-plugin
export var backupIcon = "_ms-1";
export var image = "_ms-0";